import { OutageStatusResponse } from './types';

export const OUTAGE_STATUS_SWR_KEY = '/outage';
export const OUTAGE_STATUS_REFRESH_MILLIS = 60000;

export const mapOutageStatusToIsElasticsearchOutage = (
  outageStatusResponse: OutageStatusResponse,
): boolean => {
  return (outageStatusResponse || {}).is_elasticsearch_outage!!;
};
